import React, {Component} from 'react';
import {connect} from 'react-redux';
import {howItWorksOverlay, pinboardOverlay} from '../../redux/actions';

class HowItWorks extends Component {
  render() {
    return (
      <div>
        {this.props.howItWorksActive && (
          <div className="overlay-wrapper">
            <div className="overlay-box">
              <div className="title">How does this work?</div>
              <div className="body">
                <div className="content text-center hlp-mb-30">
                  This database will allow you to find specific
                  constitution-building processes by using any of the search
                  criteria you find on the initial page or on the left column of
                  the results page (FILTERS).
                </div>

                <div className="title">
                  Viewing a constitution-building process
                </div>
                <div className="content text-center hlp-mb-30">
                  Once you have found the constitution-building process(es) you
                  have been looking for, you can either directly see the full
                  process on the search results page, by clicking on View full
                  process, including the eight stages in which we divide each
                  process, or you can download the given process using either
                  pdf (EXPORT PROCESS TO PDF) or excel (EXPORT PROCESS TO
                  EXCEL).
                </div>

                <div className="title">Pinning items</div>
                <div className="content text-center hlp-mb-30">
                  Every process is divided in eight stages, and each stage is
                  divided in a number of questions. Each and every process,
                  stage and specific question can be saved to your Pinboard, by
                  using the little pin icon on the right of each process, stage
                  and question. Once pinned, you can export processes, stages
                  and questions to a pdf document, or you can export entire
                  processes to an excel sheet, which will allow the systematic
                  comparison between different processes.
                </div>

                <div className="text-center hlp-mb-30">
                  <img src="./../images/overlay-pinning-items.png" alt="" />
                </div>
              </div>

              <div className="actions">
                <button
                  className="btn accent-invert"
                  onClick={() => {
                    this.props.howItWorksOverlay(false);
                    this.props.pinboardOverlay(true);
                  }}>
                  View pinboard
                </button>
                <button
                  className="btn primary"
                  onClick={() => this.props.howItWorksOverlay(false)}>
                  Got it
                </button>
              </div>
              <div
                className="overlay-close"
                onClick={() => this.props.howItWorksOverlay(false)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {howItWorksActive} = state.god;
  return {howItWorksActive};
};

export default connect(mapStateToProps, {
  howItWorksOverlay,
  pinboardOverlay,
})(HowItWorks);
